module.exports = "<input [id]=\"'agreement_' + labelId\" type=\"checkbox\" name=\"agreement\" [(ngModel)]=\"agreed\" (change)=\"onChange()\">\n<label [attr.for]=\"'agreement_' + labelId\" class=\"ssf-agreement__text\">\n    <ng-content></ng-content>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/agreement/agreement.component.html
// module id = 831
// module chunks = 3